import { gql, useMutation } from '@apollo/client';

const RESET_EMPLOYEE_TRAINING = gql`
  mutation resetEmployeeTraining($employeeId: String!, $applicationId: String!) {
    resetEmployeeTraining(employeeId: $employeeId, applicationId: $applicationId) {
      employeeId
      applicationId
      deleted
    }
  }
`;

export interface ResetEmployeeTrainingResult {
  resetEmployeeTraining: {
    employeeId: string;
    applicationId: string;
    deleted: number;
  };
}

export interface ResetEmployeeTrainingInput {
  employeeId: string;
  applicationId: string;
}

export function useTrainingResetMutation() {
  // Confirmations live on LocalQuestionnaire.documentConfirmations (GetTopics), so refetch it
  // to update the employee table status after the reset.
  return useMutation<ResetEmployeeTrainingResult, ResetEmployeeTrainingInput>(RESET_EMPLOYEE_TRAINING, {
    refetchQueries: ['GetTopics'],
    awaitRefetchQueries: true,
  });
}
